import React, { useCallback } from "react";
import { connect } from "react-redux";
import { selectors as contactSelectors, actions } from "../modules/contacts";
import { ContactForm } from "./ContactForm";
import { getCurrentDealer } from "../modules/dealers";
import { selectors as customerSelectors } from "../modules/customers";
import _ from "lodash";

const UpdateContactForm = connect(
  state => ({
    submittingContact: contactSelectors.isLoadingSubmitContact(state),
    failSubmitContact: contactSelectors.getFailureSubmitContact(state),
    successSubmitContact: contactSelectors.isSuccessSubmitContact(state),
    contacts: contactSelectors.getContacts(state),
    currentContact: contactSelectors.getCurrentContact(state),
    dealer: getCurrentDealer(state),
    customer: customerSelectors.getCurrentCustomer(state)
  }),
  {
    updateContact: actions.updateContact,
    setContacts: actions.setContacts,
    setCurrentContact: actions.setCurrentContact
  }
)(
  ({
    submittingContact,
    failSubmitContact,
    successSubmitContact,
    updateContact,
    setContacts,
    dealer,
    customer,
    contacts,
    currentContact,
    setCurrentContact
  }) => {
    const onSubmit = useCallback(
      async (data, { resetForm }) => {
        const { response } = await updateContact({
          dealer_id: dealer.id,
          customer_id: customer.id,
          data,
          contact_id: currentContact.id
        });
        if (response) {
          const resolvedContact = response.data;
          resetForm({ email: "", phone_number: "" });
          let nextContacts = [...contacts];
          let index = _.findIndex(nextContacts, { id: resolvedContact.id });
          if (index !== -1) {
            nextContacts.splice(index, 1, Object.assign({}, resolvedContact));
            setContacts(nextContacts);
          }
        }
      },
      [
        updateContact,
        dealer.id,
        customer.id,
        currentContact.id,
        contacts,
        setContacts
      ]
    );
    const onClickClear = useCallback(() => {
      setCurrentContact(null);
    }, [setCurrentContact]);
    return (
      <ContactForm
        onClickClear={onClickClear}
        onSubmit={onSubmit}
        currentContact={currentContact}
        submittingContact={submittingContact}
        failSubmitContact={failSubmitContact}
        successSubmitContact={successSubmitContact}
      />
    );
  }
);

export default UpdateContactForm;
